var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJobLogsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.667 12.333H3.333a2 2 0 0 1-2-2V3.667a.667.667 0 1 0-1.333 0v6.666a3.333 3.333 0 0 0 3.333 3.334h5.334a.667.667 0 0 0 0-1.334zm-4-4.666a.667.667 0 0 0 .666.666h3.334a.667.667 0 0 0 0-1.333H5.333a.667.667 0 0 0-.666.667zM12 4.96a.873.873 0 0 0-.04-.18v-.06a.713.713 0 0 0-.127-.187l-4-4a.713.713 0 0 0-.186-.126.213.213 0 0 0-.06 0 .587.587 0 0 0-.22-.074h-2.7a2 2 0 0 0-2 2V9a2 2 0 0 0 2 2H10a2 2 0 0 0 2-2V5v-.04zM8 2.607l1.727 1.726h-1.06A.667.667 0 0 1 8 3.667v-1.06zM10.667 9a.667.667 0 0 1-.667.667H4.667A.667.667 0 0 1 4 9V2.333a.667.667 0 0 1 .667-.666h2v2a2 2 0 0 0 .12.666H5.333a.667.667 0 0 0 0 1.334h5.334V9z",
    fill: "#445BC7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobLogsIcon);
export default __webpack_public_path__ + "static/media/job-logs-icon.2a15d529.svg";
export { ForwardRef as ReactComponent };